// extracted by mini-css-extract-plugin
export var buttons = "_9x-0";
export var buttonsActive = "_9x-h";
export var cancelConfirm = "_9x-1";
export var closeButton = "_9x-2";
export var column = "_9x-3";
export var container = "_9x-4";
export var detailHeader = "_9x-6";
export var detailTitle = "_9x-7";
export var detailsContent = "_9x-5";
export var header = "_9x-8";
export var headerWithClose = "_9x-9";
export var icon = "_9x-a";
export var infoIcon = "_9x-c";
export var informationContainer = "_9x-b";
export var sideDrawer = "_9x-d";
export var sideDrawerOpen = "_9x-e";
export var stickyFooter = "_9x-f";
export var typeOption = "_9x-g";